import styles from "./index.module.scss";

const Icon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16659 22C9.16659 22.7252 8.95154 23.4341 8.54864 24.0371C8.14574 24.6401 7.57309 25.11 6.90309 25.3876C6.2331 25.6651 5.49585 25.7377 4.78459 25.5962C4.07333 25.4547 3.41999 25.1055 2.9072 24.5927C2.3944 24.0799 2.04519 23.4266 1.90371 22.7153C1.76223 22.0041 1.83484 21.2668 2.11236 20.5968C2.38988 19.9268 2.85985 19.3542 3.46283 18.9513C4.06581 18.5484 4.77472 18.3333 5.49992 18.3333C6.47238 18.3333 7.40501 18.7196 8.09265 19.4073C8.78028 20.0949 9.16659 21.0275 9.16659 22Z"
      className={styles.darkToLight}
      style={{ animationDelay: "0" }}
    />
    <path
      d="M21.9999 18.3333C21.2747 18.3333 20.5658 18.5484 19.9628 18.9513C19.3598 19.3542 18.8899 19.9268 18.6124 20.5968C18.3348 21.2668 18.2622 22.0041 18.4037 22.7153C18.5452 23.4266 18.8944 24.0799 19.4072 24.5927C19.92 25.1055 20.5733 25.4547 21.2846 25.5962C21.9959 25.7377 22.7331 25.6651 23.4031 25.3876C24.0731 25.11 24.6457 24.6401 25.0486 24.0371C25.4515 23.4341 25.6666 22.7252 25.6666 22C25.6666 21.0275 25.2803 20.0949 24.5926 19.4073C23.905 18.7196 22.9724 18.3333 21.9999 18.3333Z"
      className={styles.darkToLight}
      style={{ animationDelay: ".3s" }}
    />
    <path
      d="M38.4999 18.3333C37.7747 18.3333 37.0658 18.5484 36.4628 18.9513C35.8599 19.3542 35.3899 19.9268 35.1124 20.5968C34.8348 21.2668 34.7622 22.0041 34.9037 22.7153C35.0452 23.4266 35.3944 24.0799 35.9072 24.5927C36.42 25.1055 37.0733 25.4547 37.7846 25.5962C38.4959 25.7377 39.2331 25.6651 39.9031 25.3876C40.5731 25.11 41.1457 24.6401 41.5486 24.0371C41.9515 23.4341 42.1666 22.7252 42.1666 22C42.1666 21.0275 41.7803 20.0949 41.0926 19.4073C40.405 18.7196 39.4724 18.3333 38.4999 18.3333Z"
      className={styles.darkToLight}
      style={{ animationDelay: ".6s" }}
    />
  </svg>
);

export default Icon;
